import React from "react";
import { K } from "../../theme";

export const Pill = ({ children, c = K.p }) => (
  <span
    className="inline-flex items-center px-[10px] py-[3px] rounded-pill text-[14px] font-semibold border whitespace-nowrap"
    style={{ background: `${c}18`, color: c, borderColor: `${c}30` }}
  >
    {children}
  </span>
);
